import { ContentBlockSlug, CustomContent } from '../types';
import { useContentBlockFieldParser } from './useContentBlockFieldParser';
import { parseContentBlockToggle } from '../utils';

export const useContentBlockToggle = (
  customContent: CustomContent[],
  type: string,
  { slug }: { slug: ContentBlockSlug }
) =>
  useContentBlockFieldParser(customContent, type, {
    slug,
    parser: parseContentBlockToggle
  });
